import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  headerChip: {
    margin: 12,
    borderRadius: 15
  }
})
